import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { ref } from 'vue';
import { defineStore } from 'pinia';

import * as fetchers from '@/helpers/fetchers';

export const useJobEditAddressBookStore = defineStore(
  'jobEditAddressBook',
  () => {
    const items = ref<openapi.AddressGETOpenapi[]>([]);
    const loading = ref(false);

    async function fetch(customerCode: string): Promise<void> {
      loading.value = true;
      try {
        items.value = await fetchers.fetchGetLookupAddress({
          customer: customerCode,
        });
      } finally {
        loading.value = false;
      }
    }

    function $reset(): void {
      items.value = [];
      loading.value = false;
    }

    return { items, loading, fetch, $reset };
  },
);
